import { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext } from '@tanstack/react-router';

import type { User } from '@/api';
import { NotFoundPage } from '@/pages/not-found';

import { Root } from './-root';

interface RouterContext {
  queryClient: QueryClient;
  user: User;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  notFoundComponent: NotFoundPage,
});
